
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Bell'
})
export default class Bell extends Vue {}
